import { FC } from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

const CashTransactionWithdrawalIcon: FC<SvgProps> = (props) => (
    <Svg height={16} viewBox="0 0 16 16" width={16} {...props}>
        <Path
            d="M4.03333 8.75833C3.82053 8.75833 3.63539 8.67959 3.4779 8.5221C3.32041 8.36461 3.24167 8.17947 3.24167 7.96667C3.24167 7.75387 3.32041 7.56872 3.4779 7.41123C3.63539 7.25374 3.82053 7.175 4.03333 7.175H11.9667C12.1795 7.175 12.3646 7.25374 12.5221 7.41123C12.6796 7.56872 12.7583 7.75387 12.7583 7.96667C12.7583 8.17947 12.6796 8.36461 12.5221 8.5221C12.3646 8.67959 12.1795 8.75833 11.9667 8.75833H4.03333Z"
            fill="#E90C31"
        />
    </Svg>
)

export default CashTransactionWithdrawalIcon
